import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import ProfHero from "../sections/ProfHero";
import OpportunityGrid from "../sections/OpportunityGrid";
import TransparentMatching from "../sections/TransparentMatching";
import WorkspacePanel from "../sections/WorkspacePanel";
import ProSuiteBand from "../sections/ProSuiteBand";
import ProfClosing from "../sections/ProfClosing";

const ProfessionalsPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Seo
            title="BuildEase for Construction Professionals | BuildEase Pro"
            description="BuildEase Pro (V2) is being developed for quantity surveyors, contractors, project managers and property professionals. Enquire about early access."
        />
        <Navbar />
        <main>
            <ProfHero />
            <OpportunityGrid />
            <TransparentMatching />
            <WorkspacePanel />
            <ProSuiteBand />
            <ProfClosing />
        </main>
        <Footer />
    </div>
);

export default ProfessionalsPage;
